import {
  FaAngleLeft,
  FaAngleRight,
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaArrowUp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMobileAlt,
} from 'react-icons/fa';
import {
  FaArrowRightLong,
  FaClock,
  FaDesktop,
  FaLocationDot,
  FaPhoneVolume,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';
import { IoLogoYoutube } from 'react-icons/io5';
import { GrMap } from 'react-icons/gr';
import { HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
// import { TfiEmail } from 'react-icons/tfi';
import { IoMdMail, IoMdTime } from 'react-icons/io';
export const FaIcons = {
  Facebook: FaFacebookF,
  Instagram: FaInstagram,
  LinkedIn: FaLinkedinIn,
  Twitter: FaXTwitter,
  youTube: IoLogoYoutube,
  ArrowLeft: FaArrowAltCircleLeft,
  ArrowRight: FaArrowAltCircleRight,
  ArrowRightLong: FaArrowRightLong,
  AngleLeft: FaAngleLeft,
  AngleRight: FaAngleRight,
  ArrowUp: FaArrowUp,
  location: GrMap,
  phone: HiOutlinePhone,
  email: HiOutlineMail,
  clock: IoMdTime,
  desktop: FaDesktop,
  mobile: FaMobileAlt,
};
